module.exports = __webpack_public_path__ + "img/tags.d8d79a62.svg";